import React, {useContext, useEffect} from 'react';
import { Support } from './components/Support';

export const SupportView = (props) => {

    var topics = ["General","Account", "Adding Documents","Feature Request","Other"];
    return (
        <Support topics={topics} />
    )
}